import React from 'react'
import { Alert, Box } from '@mui/material'
import AutoCompleteField from '../../../../components/form/AutoCompleteField'
import SelectField from '../../../../components/form/SelectField'
import Loader from '../../../../components/loader/Loader'
import { useAppTranslations } from '../../../../utils/hooks/useAppTranslations'
import { displayAsCurrency } from '../../../../utils/displayAsCurrency'
import { useCampaignCreateCopperContext } from './CampaignCreateCopperContext'

const CampaignCopperOpportunityFields: React.FC = () => {
  const t = useAppTranslations()
  const {
    showOpportunityPicker,
    loading,
    stageOptions,
    opportunityOptions,
    opportunityBudgetRemaining,
    selectedMonetaryValue,
  } = useCampaignCreateCopperContext()

  if (!showOpportunityPicker) return null

  return (
    <Box sx={{ position: 'relative', mb: 2 }}>
      {loading && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.paper',
            opacity: 0.7,
          }}
        >
          <Loader />
        </Box>
      )}
      <Box sx={{ pointerEvents: loading ? 'none' : 'auto' }}>
        <Box sx={{ display: 'flex', gap: 3 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <SelectField
              name={'copperOpportunityStage'}
              label={'campaign.copperOpportunityStage'}
              withNone
              fullWidth
              variant="outlined"
              options={stageOptions.map((stage) => ({ value: stage, label: stage }))}
            />
          </Box>
          <Box sx={{ flex: 2, minWidth: 0 }}>
            <AutoCompleteField
              name={'copperOpportunityId'}
              label={t('campaign.copperOpportunity')}
              options={loading ? [] : opportunityOptions}
            />
          </Box>
        </Box>
        {selectedMonetaryValue != null && opportunityBudgetRemaining > 0 && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            {t('campaign.copperOpportunityBudgetRemaining', {
              amount: displayAsCurrency(opportunityBudgetRemaining),
            })}
          </Alert>
        )}
      </Box>
    </Box>
  )
}

export default CampaignCopperOpportunityFields
